import { render, staticRenderFns } from "./RightRouterView.vue?vue&type=template&id=39eafb70"
import script from "./RightRouterView.vue?vue&type=script&lang=js"
export * from "./RightRouterView.vue?vue&type=script&lang=js"
import style0 from "./RightRouterView.vue?vue&type=style&index=0&id=39eafb70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports